import React, { Component, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import FindIdByPhone from './FindIdByPhone'
import FindIdByEmail from './FindIdByEmail'
import Alert from '../../../module/alert/'
import Header from '../../../layout/default/Header'
import { commons } from '../../../hook/common'
import $ from 'jquery'

//class FindId extends Component {
const FindId = (props) => {
  /* 	constructor(props) {
		super(props)

		this.state = {
			type: 'sms'
		}
	} */

  const [state, setState] = useState({ type: 'sms' })

  const handleTab = (type) => {
    setState({
      ...state,
      type: type,
    })
  }

  useEffect(() => {
    $('#list li').on('click', function () {
      $('#findPhone').removeClass('on')
      $('#findPhone').text($(this).text())
    })
  }, [])

  return (
    <React.Fragment>
      <Alert />

      {/* container */}
      <div id="container">
        {/* contents */}
        <div id="contents">
          <div className="content-header type2">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault()
                window.history.back()
              }}
              className="page-prev"
            >
              뒤로이동
            </a>
            {/* <!-- mobile --> */}
            <h2>아이디 찾기</h2>
            <div className="breadcrumb">
              <span>Home</span>
              <em>아이디 찾기</em>
            </div>
          </div>
          <div className="login-wrap">
            <ul className="nav-tab w124 tabs">
              <li className="on">
                <a href="#id-tab1" onClick={() => handleTab('sms')}>
                  휴대폰으로 찾기
                </a>
              </li>
              <li>
                <a href="#id-tab2" onClick={() => handleTab('email')}>
                  이메일로 찾기
                </a>
              </li>
            </ul>
            {/* <!-- mobile --> */}
            <div className="nav-wrap">
              <a href="#" id="findPhone" className="current-menu">
                휴대폰으로 찾기
              </a>
              <ul className="nav-menu" id="list">
                <li>
                  <a href="#" onClick={() => handleTab('sms')}>
                    휴대폰으로 찾기
                  </a>
                </li>
                <li>
                  <a href="#" onClick={() => handleTab('email')}>
                    이메일로 찾기
                  </a>
                </li>
              </ul>
            </div>
            {/* <!-- //mobile --> */}
            <div className="tab-container">
              <div id="id-tab1" className="tab-cont">
                {state.type === 'sms' ? <FindIdByPhone /> : ''}
              </div>
              <div id="id-tab2" className="tab-cont">
                {state.type === 'email' ? <FindIdByEmail /> : ''}
              </div>
            </div>
          </div>
        </div>
        {/* //contents */}
      </div>
      {/* //container */}
    </React.Fragment>
  )
}

export default FindId
